export default __webpack_public_path__ + "static/media/1.ddc5effb.webp";